import { useTheme } from "../../../context/theme";
import { DISABLED_OPACITY } from "../../../styles/colors/consts";
import { Box } from "../../layout";
import { Size, sizeMap } from "./consts";
import { CustomCheckboxProps, makeCustomCheckbox } from "./CustomCheckbox";

type Props = CustomCheckboxProps & {
  size: Size;
};

const TRANSITION_DURATION = "0.2s";

export default makeCustomCheckbox(Toggle);

function Toggle({ checked, size, disabled }: Props) {
  const { height, width, borderWidth } = sizeMap[size];

  const theme = useTheme();

  const color = checked
    ? theme["success-medium-content"]
    : theme["neutral-medium-content"];

  return (
    <Box
      height={`${height}px`}
      width={`${width}px`}
      boxSizing="content-box"
      borderRadius="xlarge"
      border={`${borderWidth}px solid ${color}`}
      position="relative"
      transition={TRANSITION_DURATION}
      opacity={disabled ? DISABLED_OPACITY : "1"}
    >
      <Box
        height={`${height - borderWidth * 2}px`}
        width={`${height - borderWidth * 2}px`}
        top={`${borderWidth}px`}
        left={`${borderWidth}px`}
        position="absolute"
        borderRadius="xlarge"
        backgroundColor={color}
        transition={TRANSITION_DURATION}
        transform={checked ? `translateX(${width - height}px)` : "none"}
      />
    </Box>
  );
}
